import React, { useEffect, useRef } from "react";

const UploadCandidateModal = ({
  show,
  uploading,
  file,
  uploadProgress,
  csvInputRef,
  pdfInputRef,
  handleCsvClick,
  handlePdfClick,
  handleCsvUpload,
  handlePdfUpload,
  handleCandidateUpload,
  resetUploadModal,
  downloadSampleCsv,
}) => {
  const modalInputRef = useRef(null);

  useEffect(() => {
    if (file.data.length > 0 && modalInputRef.current) {
      modalInputRef.current.scrollTop = modalInputRef.current.scrollHeight;
    }
  }, [file.data]);

  if (!show) return null;

  return (
    <div className="upload-modal">
      <div className="modal-content">
        <div className="modal-head">
          <div></div>
          <h3>Upload Candidates</h3>
          <img
            src="/images/close-icon.svg"
            alt=""
            onClick={resetUploadModal}
            disabled={uploading}
          />
        </div>
        <div
          className="modal-input"
          ref={modalInputRef}
          style={{
            height: "280px",
            overflowY: "auto",
            scrollbarWidth: "thin",
            justifyContent: "unset",
          }}
        >
          {uploading ? (
            <div
              style={{
                textAlign: "center",
                color: "#F75891",
                justifyContent: "center",
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                {["pdf", "csv"].includes(file.type) && uploadProgress.total > 0 && (
                    <p style={{ marginTop: "12px" }}>
                        {file.type === "csv"
                        ? "Uploading CSV file..."
                        : `Uploading... ${uploadProgress.current} of ${uploadProgress.total}`}
                    </p>
                )}
              </div>
            </div>
          ) : (
            <>
              <img src="/images/upload-icon-pink.svg" alt="" />
              <p>
                <strong style={{ fontWeight: 600 }}>Click to upload</strong> or
                drag and drop
              </p>
              <p>Supported formats: .xls, .csv, .docx, .pdf for resume</p>
              <p>Select a maximum of 20 .docx, .pdf or 1 csv files at a time.</p>
              <div
                className="d-flex justify-content-evenlly align-items-center"
                style={{ gap: "20px" }}
              >
                <div className="d-flex justify-content-center">
                  <button className="upload-btn" onClick={handleCsvClick} disabled={uploading}>
                    Browse csv
                  </button>
                </div>
                <div className="d-flex justify-content-center">
                  <button className="upload-btn" onClick={handlePdfClick} disabled={uploading}>
                    Browse resumes
                  </button>
                </div>
              </div>

              <input
                ref={csvInputRef}
                type="file"
                accept=".xls,.csv"
                onChange={handleCsvUpload}
                style={{ display: "none" }}
              />
              <input
                ref={pdfInputRef}
                type="file"
                accept=".pdf,.docx"
                onChange={handlePdfUpload}
                style={{ display: "none" }}
                multiple
              />

              {file.data.length > 0 && (
                <div style={{ marginTop: "16px", textAlign: "left" }}>
                  <p>
                    Selected {file.type === "csv" ? "CSV" : "PDF"} File
                    {file.data.length > 1 ? "s" : ""}:
                  </p>
                  <ol style={{ marginBottom: "0" }}>
                    {file.data.map((f, idx) => (
                      <li key={idx}>
                        <p>
                          <strong>{f.name}</strong>
                        </p>
                      </li>
                    ))}
                  </ol>
                </div>
              )}

              <div style={{ marginTop: "1rem", textAlign: "center" }}>
                <p>
                  <strong
                    onClick={(e) => {
                      e.preventDefault();
                      downloadSampleCsv();
                    }}
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Click here
                  </strong>{" "}
                  to download the sample CSV
                </p>
              </div>
            </>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            className="upload-btn"
            onClick={handleCandidateUpload}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Upload candidates"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadCandidateModal;
